import { ExperimentStore } from 'bernie-plugin-mobx';

export const isExperimentEnabled = (experimentStore: ExperimentStore, experimentName: string) => {
  return (
    experimentStore &&
    experimentStore.exposures &&
    experimentStore.exposures[experimentName] &&
    experimentStore.exposures[experimentName].bucket > 0
  );
};
